import { useRouter } from 'next/router';

/**
 * Returns the current route name. Empty string for home
 */
export function useCurrentRoute(): string {
  const { query } = useRouter();

  if (
    query['route'] &&
    query['route'].length > 0 &&
    typeof query['route'][0] !== 'undefined'
  ) {
    return query['route'][0];
  }

  return '';
}
